import React from 'react';
import moment from 'moment';

import { useDialog } from 'utils/hooks';
import { getTermsAndConditionsURL } from 'utils/helpers';
import { texts } from 'utils/languages/fr';

import ContactDialog from './ContactDialog';
import { PDFDialog } from 'components';
import { Box, Typography, Link } from '@mui/material';

const footerSx = theme => ({
    backgroundColor: 'common.black',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 45px',
    height: `${theme.constants.footerHeight}px`,
    flex: `0 0 ${theme.constants.footerHeight}px`,
    gap: 2,
    [theme.breakpoints.down('md')]: { flexDirection: 'column', padding: '20px 30px' },
});
const copyrightSx = {
    fontSize: '13px',
    opacity: 0.6,
    color: 'common.white',
};
const linkContainerSx = theme => ({
    flex: '1 1',
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    gap: 2,
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 0,
    },
});
const linkSx = { fontSize: '13px', textTransform: 'uppercase', color: 'common.white' };

const Footer = () => {
    const {
        open: contactOpen,
        onOpen: handleOpenContact,
        onClose: handleCloseContact,
    } = useDialog();
    const {
        open: conditionsOpen,
        onOpen: handleOpenConditions,
        onClose: handleCloseConditions,
    } = useDialog();

    return (
        <Box id="footer" sx={footerSx}>
            <Box>
                <Typography sx={copyrightSx}>
                    {texts.COPYRIGHT} {moment().get('year')}
                </Typography>
            </Box>
            <Box sx={linkContainerSx}>
                <ContactDialog open={contactOpen} onCancel={handleCloseContact} />
                <PDFDialog
                    open={conditionsOpen}
                    onClose={handleCloseConditions}
                    title={texts.CONDITIONS_GENERALES}
                    url={getTermsAndConditionsURL()}
                />
                <Typography
                    display="inline"
                    sx={{ ...linkSx, cursor: 'pointer', ':hover': { textDecoration: 'underline' } }}
                    onClick={handleOpenContact}
                >
                    {texts.CONTACT}
                </Typography>
                <Link
                    display="inline"
                    sx={linkSx}
                    href={process.env.REACT_APP_GENERAL_CONDITIONS_URL}
                    target="_blank"
                    onClick={e => {
                        e.preventDefault();
                        handleOpenConditions();
                    }}
                >
                    {texts.CONDITIONS_GENERALES}.
                </Link>
            </Box>
        </Box>
    );
};

export default Footer;
